import { useContext, useEffect, useState } from "react";

import { AppContext } from "../../data/AppContextContainer";
import { getPropertyRecurringIssues } from "../../services/api";

const useRecurringIssues = (propertyId, bookingId) => {
  const { showNotification } = useContext(AppContext);

  const [recurringIssues, setRecurringIssues] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRecurringIssues = async () => {
      if (!propertyId || !bookingId) return;

      setLoading(true);

      try {
        const { data } = await getPropertyRecurringIssues(
          propertyId,
          bookingId
        );

        setRecurringIssues(data.issues);
      } catch (error) {
        showNotification({
          title: "Error",
          message: "Failed to fetch recurring issues",
          type: "negative"
        });
      } finally {
        setLoading(false);
      }
    };

    fetchRecurringIssues();
  }, [propertyId, bookingId, showNotification]);

  return {
    recurringIssues,
    loading
  };
};

export default useRecurringIssues;
